/*----------------------------------------------------------------------------
//    HP Contants header widget tab
//    written by Malathesha Sahukar
//    Date: September 2020
\---------------------------------------------------------------------------*/

import React from 'react';

import { BasicAlert, DDLabel } from '../common/components.jsx';

export class HPContacts extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      contactsData: {},
      accContacts: {},
      orgDataStatus: 'NA',
      accContactsStatus: 'L',
      errStatus: '',
      searchParam: ''
    }

    this.handleError = this.handleError.bind(this);
  }

  componentDidMount() {
    /* HOM-3990 - Decommission of Org Relation Table in OSS
    // hide org data for int. widget - HOM 3498
    if (typeof this.props.caller !== 'undefined' && this.props.caller == 'osv') {
      this.getContactsData(this.props.order.legacy_order_no)
    } else {
      this.setState({ orgDataStatus: 'NA'})
    }
    */
    this.getAccountContacts(this.props.order.legacy_order_no);

    const order = this.props.order;
    // set the search param for account viewer punch out
    let searchParam = '';
    if (order.end_cust_mdm_st_top_id && order.end_cust_mdm_st_top_id != '') {
      searchParam = order.end_cust_mdm_st_top_id;
    } else if (order.sold_to_mdm_st_top_id && order.sold_to_mdm_st_top_id != '' ) {
      searchParam = order.sold_to_mdm_st_top_id;
    } else if (order.contract_master_no && order.contract_master_no != '') {
      searchParam = order.contract_master_no;
    } else if (order.contract_no && order.contract_no != '' ) { 
      searchParam = order.contract_no;
    }
    this.setState({ searchParam });
  }

  /* HOM-3990 - Decommission of Org Relation Table in OSS
  getContactsData(lon) {

    GET('/os/ossui/v1/in/widgetExpert/contactInfo?lon=' + lon, {}, function (res) {
      var contactsData = {}
      if (res.status == 'S') {
        res.data.map(function (contact) {
          if (true || contact.account) {
            contactsData = contact;
          }
          return contact;
        })
        this.setState({ ...this.state, contactsData: contactsData })
      }
      this.setState({ orgDataStatus: res.status })
    }.bind(this), this.handleError)

  }
  */

  getAccountContacts(lon) {

    GET('/os/ossui/v1/in/widgetExpert/accountContacts?lon=' + lon, {}, function (res) {
      var accContacts = {}
      if (res.status == 'S') {
        accContacts = res.data;
        this.setState({ ...this.state, accContacts: accContacts })
      }
      this.setState({ accContactsStatus: res.status })
    }.bind(this), this.handleError)

  }

  handleError(statusText) {
    if (statusText == "error") {
      this.setState({ errStatus: 'E' })

    } else if (statusText == "timeout") {
      this.setState({ errStatus: 'T' })
    }
  }

  render() {

    var order  = this.props.order;
    var caller = typeof this.props.caller !== 'undefined' ? this.props.caller : 'osv';

    if (caller === 'ext_widget') {

      var { accContacts } = this.state;

      return (
        <div className="hdrGridContainer">
          <table className="hdrGrid">
            <tbody>
              <tr>
                <th><DDLabel field={DD('om_contact_team_email',   'ext_widget')}   /></th><td>{accContacts.acct_hp_contact_email ?? ''}</td>
                <th><DDLabel field={DD('acct_regional_aom_email', 'ext_widget')}   /></th><td>{accContacts.acct_regional_aom_email ?? ''}</td>
                <th><DDLabel field={DD('acct_sales_email',        'ext_widget')}   /></th><td>{accContacts.acct_sales_email ?? ''}</td>
              </tr>
            </tbody>
          </table>
          {this.state.errStatus !== '' && <BasicAlert type={this.state.errStatus} />}
        </div>
      )
    }

    let orderContactsRows = null;

    if (caller === 'osv') {
      orderContactsRows = <>
        <table className="hdrGrid">
          <tbody>
            <tr>
              <th className="hdrGridSeparator" colSpan="10">{T('Order Contacts')}</th>
            </tr>
            <tr>
              <th><DDLabel field="om_contact_person_email"   /></th><td>{order.om_contact_person_email}</td>
              <th><DDLabel field="om_contact_team_name"      /></th><td>{order.om_contact_team_name}</td>
              <th><DDLabel field="odesk_agent_id"            /></th><td>{order.odesk_agent_id}</td>
              <th><DDLabel field="om_contact_source"         /></th><td>{order.om_contact_source}</td>
            </tr>
            <tr>
              <th><DDLabel field="om_contact_team_email"     /></th><td>{order.om_contact_team_email}</td>
              <th><DDLabel field="team_id"                   /></th><td>{order.team_id}</td>
              <th></th><td></td>
            </tr>
          </tbody>
        </table>
      </>
    }

    let orgRelationGrid = null;
    let accContactsGrid = null;

    var { contactsData, accContacts } = this.state

    /* HOM-3990 - Decommission of Org Relation Table in OSS
    if (this.state.orgDataStatus === 'S') {

      if (contactsData.account == '') {
        var account = order.account_name;
      } else {
        var account = contactsData.account;
      }

      orgRelationGrid = <>
        <table className="hdrGrid">
          <tbody>
            <tr>
              <th className="hdrGridSeparator" colSpan="10">{T('Org Relation Data')}</th>
            </tr>
            <tr>
              <th><DDLabel field="fo_name"                 /></th><td>{contactsData.fo_name}</td>
              <th><DDLabel field="account_service_level"   /></th><td>{contactsData.account_service_level}</td>
              <th><DDLabel field="sales_support_name"      /></th><td>{contactsData.sales_support_name}</td>
              <th><DDLabel field="bo_name"                 /></th><td>{contactsData.bo_name}</td>
            </tr>
            <tr>
              <th><DDLabel field="fo_email"                /></th><td>{contactsData.fo_email}</td>
              <th><DDLabel field="account_country"         /></th><td>{contactsData.account_country}</td>
              <th><DDLabel field="sales_support_email"     /></th><td>{contactsData.sales_support_email}</td>
              <th><DDLabel field="bo_email"                /></th><td>{contactsData.bo_email}</td>
            </tr>
            <tr>
              <th><DDLabel field="fo_manager"              /></th><td>{contactsData.fo_manager}</td>
              <th><DDLabel field="account_name"            /></th><td>{account}</td>
              <th><DDLabel field="aom_manager_email"       /></th><td>{contactsData.aom_manager_email}</td>
              <th><DDLabel field="sales_contact_name"      /></th><td>{contactsData.sales_contact_name}</td>
            </tr>
            <tr>
              <th><DDLabel field="fo_team"                 /></th><td>{contactsData.fo_team}</td>
              <th><DDLabel field="OrgRelationKey"          /></th><td>{contactsData.key}</td>
              <th><DDLabel field="account_manager"         /></th><td>{contactsData.account_manager}</td>
              <th></th><td></td>
            </tr>
            <tr>
              <th><DDLabel field="sales_contact_email"     /></th><td>{contactsData.sales_contact_email}</td>
              <th><DDLabel field="OrgRelationValue"        /></th><td>{contactsData.value}</td>
              <th><DDLabel field="account_manager_email"   /></th><td>{contactsData.account_manager_email}</td>
              <th></th><td></td>
            </tr>
          </tbody>
        </table>
      </>
    }
    */

    if (this.state.accContactsStatus === 'S') {

      let gridHeaderRow = null;

      if (caller === 'osv') {

        var btnColor = this.state.searchParam != "" ? "#0096d6" : "#7f7f7f";
        var btnBgColor = this.state.searchParam != "" ? "white" : "#e7e7e7"
        var disabled = this.state.searchParam != "" ? false: true

        gridHeaderRow = <>
          <tr>
            <th className="hdrGridSeparator" colSpan="10">{T('Account Contacts')}&nbsp;&nbsp;
              <a className="btn btn-primary btn-smallest" style={{'float': 'right', 'color': btnColor,'vertical-align': 'unset','text-decoration':'none','background-color':btnBgColor,'border': 'none'}}
                  href={`/static/dist/acctContactViewer.html?search=${this.state.searchParam}`} target="_blank" disabled={disabled}>
                <i className="glyphicon glyphicon-new-window"></i>
                  &nbsp;Account Contact Viewer
              </a>
            </th>
          </tr>
        </>
      }

      let widthStyle = { 'maxWidth': '25vw' }

      accContactsGrid = <>
        <table className="hdrGrid">
          <tbody>
            {gridHeaderRow}
            <tr>
              <th><DDLabel field={DD('acct_om_pers_email',      caller)}    /></th><td>{accContacts.acct_om_pers_email}</td>
              <th><DDLabel field={DD('acct_global_aom_email',   caller)}    /></th><td>{accContacts.acct_global_aom_email}</td>
              <th rowSpan={3}><DDLabel field={DD('acct_sales_email',        caller)}    /></th><td rowSpan={3} style={widthStyle}>{accContacts.acct_sales_email}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('acct_om_pers_sec_email',  caller)}    /></th><td>{accContacts.acct_om_pers_sec_email}</td>
              <th><DDLabel field={DD('acct_regional_aom_email', caller)}    /></th><td>{accContacts.acct_regional_aom_email}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('acct_om_gen_email',       caller)}    /></th><td>{accContacts.acct_om_gen_email}</td>
              <th><DDLabel field={DD('acct_inside_aom_email',   caller)}    /></th><td>{accContacts.acct_inside_aom_email}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('acct_om_mgr_email',       caller)}    /></th><td>{accContacts.acct_om_mgr_email}</td>
              <th><DDLabel field={DD('acct_cat_mgr_pers_email', caller)}    /></th><td>{accContacts.acct_cat_mgr_pers_email}</td>
              <th rowSpan={2}><DDLabel field={DD('acct_sales_mgr_email',    caller)}    /></th><td rowSpan={2} style={widthStyle}>{accContacts.acct_sales_mgr_email}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('acct_scoah_gen_email',    caller)}    /></th><td>{accContacts.acct_scoah_gen_email}</td>
              <th><DDLabel field={DD('acct_cat_mgr_gen_email',  caller)}    /></th><td>{accContacts.acct_cat_mgr_gen_email}</td>
            </tr>
            <tr>
              <th><DDLabel field={DD('acct_om_team',            caller)}    /></th><td>{accContacts.acct_om_team}</td>
              <th><DDLabel field={DD('acct_ebiz_cons_email',    caller)}    /></th><td>{accContacts.acct_ebiz_cons_email}</td>
              <th></th><td></td>
            </tr>
          </tbody>
        </table>
      </>
    }

    return (
      <div className="hdrGridContainer">
        {orderContactsRows}
        {accContactsGrid}
        {orgRelationGrid}
        {this.state.orgDataStatus === 'L' || this.state.accContactsStatus === 'L' ? <BasicAlert type={'L'} /> : null}
        {this.state.errStatus !== '' && <BasicAlert type={this.state.errStatus} />}
        {caller == 'int_widget' && this.state.accContactsStatus == 'N' && <BasicAlert type={'N'} />}
      </div>
    )
  }

}
